import React, { useState } from "react";
import "./component.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import SingingContract from "../../../assests/SingingContract.svg";
import { Button, Box, TextField } from "@mui/material";
import leftArrow from "../../../assests/leftArrow.svg";
import { Link, useNavigate, useHistory } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import LoadingSpinner from "../../Loading/component";

export const CouponPGComponent = ({
    handleCouponCashbackFlatAmountChange,
    handleCouponCashbackPercentageAmountChange,
    couponCreationStep13,
    flatAmount,
    handleBtnClick,
    activeBtn,
    percentageAmount,
    handleCouponCashbackChange,
    newPgIds,
handleAddPgId,
handleChangePG,
pgIds,
   
}) => {
    
      
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };
  const goback = () => {
    navigate(-1);
  };
  
  return (
    <div className="main-div">
      <div>
        <Sidebar />
      </div>

      <div>
        <div style={{ marginLeft: "42px", marginTop: "20px" }}>
          <h2>
            <img
              onClick={handleClick}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />{" "}
            Create Coupon
          </h2>
        </div>
        <div className="bDetrails-div">
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              width: "1328px",
            }}
          >
            <div className="inputDiv">
      <Box
        sx={{
          width: 600,
          maxWidth: "100%",
          alignItems: "center"
        }}
      >
        <label htmlFor="" className="couponLabel">
        Is it only applicable on certain Payment gateways?
        </label>
        <div>
        <div className="cashback-div">
      <button
        className={`cashback-btn ${
          activeBtn === "Yes" ? "active-btn" : "inactive-btn"
        }`}
        onClick={() => handleBtnClick("Yes")}
      >
        Yes
      </button>
      <button
        className={`cashback-btn ${
          activeBtn === "No" ? "active-btn" : "inactive-btn"
        }`}
        onClick={() => handleBtnClick("No")}
      >
        No
      </button>
     
    </div>

        
 {activeBtn === "Yes" && (
    <>
       <TextField
       style={{ margin: "18px", padding: "0px", color: "#b2b2b2" }}
       fullWidth
       label="Enter Payment gateway ID"
      type="number"
       value={newPgIds}
       onChange={handleChangePG}
     />

<div style={{display:"flex", justifyContent:"end", width:"800", margin:"auto", textAlign:"end", flexDirection:"row"}}>
<button style={{border:"none ", backgroundColor:"none", color:"blue", }} variant="primary" onClick={handleAddPgId}>+add</button>

</div>



<div style={{ width:"1200px", marginTop:"240px", display:"flex", height:"90px", flexDirection:"row", marginLeft:"30px", padding:"10px",background: "#F6F6F6"
,borderRadius: "15px"}}> Add PG ids :  {pgIds.map((id) => (
        <div key={id} >{id}</div>
      ))} </div>

     </>
     
      )}

        </div>
        
      </Box>
     
     
      <Box className="usersrolebtn">
        <Button className="backbtn" onClick={goback}>
          Cancel
        </Button>


<Button
            variant="contained"
            onClick={() => couponCreationStep13(activeBtn === 'flat' ? 1 : 2)}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              width: 120,
              height: 40,
              background:"rgba(0, 177, 119, 1)",
            }}
          >
            NEXT
          </Button>
      </Box>
      
    </div>
          </div>
          
        </div>
        
      </div>
    </div>
  );
};
